import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ic_error.svg")